import React, {
  useContext,
  useState,
  useRef,
  useEffect,
  Fragment,
} from "react";
import PropTypes from "prop-types";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import LocalStorageValues from "./LocalStorageValues";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Sort,
  Group,
} from "@syncfusion/ej2-react-grids";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import DvrIcon from "@mui/icons-material/Dvr";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PaidIcon from "@mui/icons-material/Paid";
import Tour from "./Tour";
import "./styles/DashboardAllProjects.css";

function DashboardAllProjects_ff(props) {
  sessionStorage.removeItem("dashboardTaskList");
  sessionStorage.removeItem("dashboardAttachmentList");
  const TOUR_ID = "DashboardAllProjects";
  const [dirty, isDirty] = useState(false);
  const loadedCreds = localStorage.getItem("instanceInfo");
  let parsedCreds;
  if (loadedCreds && loadedCreds.indexOf("company") == -1) {
    parsedCreds = JSON.parse(Tools.decrypt(loadedCreds));
  } else {
    parsedCreds = JSON.parse(loadedCreds);
  }
  const creds = useContext(CredsContext).creds || parsedCreds;
  const setCreds = useContext(CredsContext).setCreds;
  const lsv = new LocalStorageValues(creds, setCreds);
  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);
  const displayTable = useRef();
  const rawFavorites = localStorage.getItem(
    creds.company + "|FavoriteProjects",
  );

  const initialTourState = {
    //key: new Date(),
    run: false,
    loading: false,
    stepIndex: 0,
    steps: [
      {
        target: ".tour-stop-1",
        content: (
          <Box>
            <p>Welcome to Collab Center!</p>
            <p>This is the main project list view.</p>
            <p>
              Clicking on a project name in this column will open the Collab
              Center&apos;s tools for that project.
            </p>
          </Box>
        ),

        disableBeacon: true,
      },
      {
        target: ".tour-stop-2",
        content: (
          <Box>
            <p>These columns show the time-based metrics for each project.</p>
            <ul>
              <li>Budgeted hours for the project</li>
              <li>
                Actual project hours from all timesheets in SuiteProjects Pro
              </li>
              <li>Expected hours to complete the project (ETC)</li>
              <li>Expected hours upon project completion (EAC)</li>
              <li>Difference between budget hours and EAC (+/-)</li>
            </ul>
          </Box>
        ),
      },
    ],
  };

  localStorage.removeItem("projectObject");
  sessionStorage.removeItem("dashboardConfig");
  sessionStorage.removeItem("dashboardItemList_risk");
  sessionStorage.removeItem("dashboardItemList_action");
  sessionStorage.removeItem("dashboardItemList_assumption");
  sessionStorage.removeItem("dashboardItemList_issue");
  sessionStorage.removeItem("dashboardItemList_decision");

  let grid;
  // let toolTip;

  lsv.initializeGlobalDefaults();
  /*
  const beforeRender = (args) => {
    if (args.target.classList.contains("e-rowcell")) {
      toolTip.content = args.target.innerText.substring(
        args.target.innerText.indexOf("\n") + 2,
      );
    }
  };

  let toolTipAnimation = {
    open: {  delay: 1000 },
    close: {  duration: 500, delay: 0 },
  };
*/
  let customerid = creds.client;

  const handleProjectClick = async (event) => {
    props.waitHandler(true);
    const projmetrics = Tools.calculateProjectMetrics(event.data, creds);

    const loadingValues = await lsv.initializeProjectValues(event.data);
    // event.data is a project object ?

    // "props.onClick" calls the refreshDashboard function in the CollaborationCompanionToolbar component
    props.onClick(
      -1,
      event.data.id,
      event.data.name,
      event.data.oada_discussion__c,
      projmetrics,
      event.data,
    );
  };

  useEffect(() => {
    if (grid) {
      grid.getColumnByField("name").disableHtmlEncode = false;

      const headerCells = grid
        .getHeaderContent()
        .querySelectorAll(".e-headercell");
      headerCells.forEach((headerCell) => {
        headerCell.style.height = "30px";
        headerCell.style.background = "#154360";
      });
    }
  }, [grid]);

  const projectColumnHeaderTemplate = (info) => {
    return (
      <Stack direction="row" alignItems="center" gap={1}>
        <DvrIcon />
        <Typography
          className="tour-stop-1"
          sx={{
            color: "black",
            fontWeight: "bold",
            fontSize: "large",
          }}
        >
          {info.headerText}
        </Typography>
      </Stack>
    );
  };

  useEffect(() => {
    let requestString;
    if (creds.userType == "generic") {
      requestString = authString;
      requestString +=
        '<Read type="Project" method="equal to" limit="1000" enable_custom="1" order="name"><Project><customerid>' +
        customerid +
        "</customerid></Project></Read></request>";
    } else {
      if (rawFavorites && rawFavorites != "[]") {
        requestString = authString;
        const favoritesArray = JSON.parse(rawFavorites);
        favoritesArray.forEach((favoriteRecord) => {
          requestString +=
            '<Read type="Project" method="equal to" limit="1000" enable_custom="1" order="name"><Project><id>' +
            favoriteRecord.projectId +
            "</id></Project></Read>";
        });
        requestString += "</request>";
      }
    }
    if (requestString) {
      //props.waitHandler(true);
      lsv.findNewProjects();
      Tools.fetchPost(requestString, urlString, "Project").then(
        (projectRecord) => {
          let projArray = [];
          for (let i = 0; i < projectRecord.xml.length; i++) {
            let projObject = {};
            for (const entry of projectRecord.xml[i].childNodes.entries()) {
              const fieldName = entry[1].nodeName;
              const node = projectRecord.xml[i].childNodes[entry[0]];

              // Check if this is a Date node with nested year/month/day structure
              let fieldValue;
              if (
                node.childNodes.length > 0 &&
                node.querySelector("year, month, day")
              ) {
                // Parse nested date structure to MMddyyyy format
                const year = node.querySelector("year")?.textContent || "";
                const month = node.querySelector("month")?.textContent || "";
                const day = node.querySelector("day")?.textContent || "";

                if (year && month && day) {
                  // Format as MMddyyyy (pad month and day with leading zeros if needed)
                  fieldValue =
                    month.padStart(2, "0") + day.padStart(2, "0") + year;
                } else {
                  fieldValue = node.textContent;
                }
              } else {
                fieldValue = node.textContent;
              }

              projObject = { ...projObject, [fieldName]: fieldValue };
            }
            if (projObject && projObject.oada_bill_type__c == "FF") {
              projObject.start_date_formatted =
                projObject.start_date.substring(4, 8) +
                "-" +
                projObject.start_date.substring(0, 2) +
                "-" +
                projObject.start_date.substring(2, 4);
              projObject.finish_date_formatted =
                projObject.finish_date.substring(4, 8) +
                "-" +
                projObject.finish_date.substring(0, 2) +
                "-" +
                projObject.finish_date.substring(2, 4);
              if (projObject.budget > 0) {
                projObject.budget_percent =
                  (Math.round(
                    projObject.oada_actual_money__c / projObject.budget,
                  ) /
                    100) *
                  100;
              } else {
                projObject.budget_percent = 0;
              }

              projArray.push(projObject);
            }
          }

          for (let j = 0; j < projArray.length; j++) {
            if (projArray[j].oada_project_health__c !== "") {
              projArray[j].displayName =
                projArray[j].name +
                " [[" +
                projArray[j].oada_project_health__c +
                "]]";
            } else {
              projArray[j].displayName = projArray[j].name;
            }
          }

          const nameColumnTemplate = (obj) => {
            let chipColor = "silver";
            let chipTextColor = "white";
            if (obj.oada_project_health__c == "Green") {
              chipColor = "green";
            } else if (obj.oada_project_health__c == "Yellow") {
              chipColor = "gold";
              chipTextColor = "black";
            } else if (obj.oada_project_health__c == "Red") {
              chipColor = "crimson";
            }

            const healthIndex = obj.displayName.indexOf("[[");
            //let displayNameObject = <span>{obj.displayName}</span>;
            let newDisplayName = obj.displayName;
            if (healthIndex != -1) {
              newDisplayName = obj.displayName.substring(0, healthIndex);
            }
            let displayNameObject = (
              <>
                <Chip
                  size="small"
                  label={
                    healthIndex != -1 ? obj.oada_project_health__c : "Status?"
                  }
                  sx={{
                    backgroundColor: [chipColor],
                    color: [chipTextColor],
                    width: "70px",
                  }}
                />
                <span>&nbsp;&nbsp;{newDisplayName}</span>
              </>
            );
            return displayNameObject;
          };

          const groupOptions = {
            columns: ["customer_name"],
            showDropArea: false,
            captionTemplate:
              '<span style="color:white;background-color:#643f69;border-radius:10px;padding-left:6px;padding-right:6px;padding-top:2px;padding-bottom:2px">${key}</span>',
          };

          displayTable.current = (
            <Fragment>
              <Tour initialState={initialTourState} width={500} id={TOUR_ID} />
              <Box sx={{ border: "solid 2px" }}>
                <GridComponent
                  dataSource={projArray}
                  ref={(g) => (grid = g)}
                  rowSelected={handleProjectClick}
                  allowSorting={true}
                  allowGrouping={creds.userType == "generic" ? false : true}
                  groupSettings={groupOptions}
                  enableStickyHeader={true}
                  cssClass="dashAllProjectsGrid"
                >
                  <Inject services={[Sort, Group]} />
                  <ColumnsDirective>
                    <ColumnDirective
                      field="displayName"
                      headerText="Project"
                      headerTemplate={projectColumnHeaderTemplate}
                      width="150"
                      textAlign="Left"
                      template={nameColumnTemplate}
                      customAttributes={{ class: "projectsTableNameCell" }}
                      allowSorting={true}
                    />
                    <ColumnDirective
                      field="customer_name"
                      headerText="Customer"
                      //headerTemplate={projectHeaderTemplate}
                      width="150"
                      textAlign="Left"
                      //template={nameColumnTemplate}
                      customAttributes={{ class: "projectsTableNameCell" }}
                      visible={false}
                    />
                    <ColumnDirective
                      field="start_date_formatted"
                      headerText="Start Date"
                      headerTemplate={projectColumnHeaderTemplate}
                      width="150"
                      textAlign="Left"
                      //template={nameColumnTemplate}
                      customAttributes={{ class: "projectsFFDataCell" }}
                      allowSorting={true}
                    />
                    <ColumnDirective
                      field="finish_date_formatted"
                      headerText="Expected End Date"
                      headerTemplate={projectColumnHeaderTemplate}
                      width="150"
                      textAlign="Left"
                      //template={nameColumnTemplate}
                      customAttributes={{ class: "projectsFFDataCell" }}
                      allowSorting={true}
                    />
                    <ColumnDirective
                      field="budget"
                      headerText="Budget"
                      headerTemplate={projectColumnHeaderTemplate}
                      width="150"
                      textAlign="Left"
                      valueAccessor={Tools.currencyFormatterNoDecimal}
                      customAttributes={{ class: "projectsFFDataCell" }}
                      allowSorting={true}
                    />
                    <ColumnDirective
                      field="oada_actual_money__c"
                      headerText="Invoiced"
                      headerTemplate={projectColumnHeaderTemplate}
                      width="150"
                      textAlign="Left"
                      valueAccessor={Tools.currencyFormatterNoDecimal}
                      customAttributes={{ class: "projectsFFDataCell" }}
                      allowSorting={true}
                    />
                    <ColumnDirective
                      field="budget_percent"
                      headerText="% of Budget"
                      headerTemplate={projectColumnHeaderTemplate}
                      width="150"
                      textAlign="Left"
                      //template={nameColumnTemplate}
                      customAttributes={{ class: "projectsFFDataCell" }}
                      allowSorting={true}
                    />
                    {/*<ColumnDirective
                      field="oada_latest_news__c"
                      headerText="Latest News Message"
                      headerTemplate={projectColumnHeaderTemplate}
                      width="450"
                      textAlign="Left"
                      //template={nameColumnTemplate}
                      customAttributes={{ class: "projectsFFDataCell" }}
                      allowSorting={true}
                    />*/}
                  </ColumnsDirective>
                </GridComponent>
              </Box>
            </Fragment>
          );
          isDirty(!dirty);
          props.waitHandler(false);
        },
      );
    }
  }, []);

  return <Fragment>{displayTable.current}</Fragment>;
}

export default DashboardAllProjects_ff;

DashboardAllProjects_ff.propTypes = {
  onClick: PropTypes.func,
  waitHandler: PropTypes.func,
};
